import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaRegFileLines } from 'react-icons/fa6';
import SalaryDeductions from "./index";
import ViewSalaryDeduction from "./view";
import EditSalaryDeduction from "./edit";
import { MODULE_SAL_DEDUCTIONS } from "variables/constants";

const salaryDeductionRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Salary Deductions",
		basePath: "salary-deductions",
		mainComponent: <SalaryDeductions />,
	    layout: "/console",	   
	    icon: <FaRegFileLines className="icon-item" />,
	    subTitle:"Salary Deduction",
	    viewComponent: <ViewSalaryDeduction />,
	    createComponent: <EditSalaryDeduction />,
	    editComponent: <EditSalaryDeduction />,
		level:3,
		moduleId: MODULE_SAL_DEDUCTIONS,
	})
]

export default salaryDeductionRoutes;